<template>
    <div class="uplound">
            <el-steps :active="3" >
                <el-step title="上传文件" icon="el-icon-edit"></el-step>
                <el-step title="进行提炼" icon="el-icon-upload"></el-step>
                <el-step title="生成报告" icon="el-icon-picture"></el-step>
            </el-steps>
            <div>
                <ul style="list-style:none;">
                    <li class="explain" style="margin:15px 0px;">
                        <div class="explain_item">
                            <span class="explain_item_span">支持</span>
                            <span class="triangle"><img style="height:27px;" src="../../assets/img/箭头.png" alt=""></span>
                            <span>pdf文件,单条或批量</span>
                        </div>
                    </li>
                    <li class="explain" style="margin:20px 0px;">
                        <div class="explain_item">
                            <span class="explain_item_span">有效期</span>
                            <span class="triangle"><img style="height:27px;" src="../../assets/img/箭头.png" alt=""></span>
                            <span>报告在平台保留一周,并且在一周内适用于多次下载报告使用</span>
                        </div>
                    </li>
                    <li>
                        <div>
                            <div style="font-weight: 700;font-size: 16px;color: #18402f;">是否翻译 </div>
                            <div style="margin-top: 10px;width:70%">
                                <el-radio v-model="radio" label="0">不翻译</el-radio>
                                <el-radio v-model="radio" label="1">翻译</el-radio>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="upload_tab">
                            <div class="upload_tab_item">
                                <span> <i class="el-icon-folder-add"></i> 文件上传</span>
                            </div>
                        </div>
                        <div class="upload_file">
                            <div class="flex">
                                <div class="upload_demo">
                                    <el-upload
                                    class="upload-demo"
                                    drag
                                    ref="upload"
                                    accept=".pdf"
                                    :show-file-list="true"
                                    :auto-upload="false"
                                    :on-change="upload"
                                    :file-list="fileList"
                                    :before-remove="remove"
                                    :on-remove="removefile"
                                    action="#"
                                    multiple>
                                    <i class="el-icon-upload"></i>
                                    <div class="el-upload__text">点击上传</div>
                                    </el-upload>
                                </div>
                                <div class="upload_tip">
                                    <img src="../../assets/img/tip.png" class="upload_tip_img" alt="">
                                    <div class="upload_tip_text">
                                        <ul class="ulStyle">
                                            <li class="upload_tip_p">仅支持英语期刊原创论文（Articles）的切分提取翻译</li>
                                            <li class="upload_tip_p">文档大小必须小于 30MB</li>
                                            <li class="upload_tip_p">文件上传仅限于支持pdf格式文件</li>
                                            <li class="upload_tip_p">上传扫描版PDF可能将会影响您的使用体验</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <div style="text-align:center;margin:30px 0px;">
                    <el-button type="primary" @click="next" >确认上传</el-button>
                </div>
            </div>
            <el-dialog
            title="温馨提示"
            :visible.sync="dialog"
            width="25%"
            >
            <span style="font-weight: 700;">文件上传成功!</span>
            <p style="margin-top:20px;font-size:16px;">Scholarcy提炼功能针对英语期刊原创论文（Articles）提取效果最佳</p>
            </el-dialog>
    </div>
</template>

<script>
export default {
    name:"",
    data(){
        return{
            input:"",//输入标题
            fileList:[], // 上传列表
            qusList:[],//有问题的列表
            dialog:false,//上传成功,移除成功
            radio:"1",//是否翻译,默认1翻译   0不翻译
            file_name:"",
            proportion:"",
            text:['系统检测到您上传的'],
            i:0
        }
    },
    created(){

    },
    methods: {
        removefile(file,fileList){
             this.fileList = fileList
        },  
        // 删除
        remove(file,fileList){
             return this.$confirm(`确定移除 ${ file.name }？`)
        },
        // 上传
        upload(file,fileList){
            // 如果文件大小大于30MB提示文件太大，并删除已上传文件
            if(file.size > 31457280){
                this.$message.error("文档大小必须小于 30MB");
                this.fileList = []
                return false
            }
            this.fileList.push(file)
            this.file_name = file.name
        
        },
        // 点击确认上传
        next(){
            console.log(this.fileList);
            if(this.fileList.length == 0){
                this.$message.error("请选择你要上传的文件");
            }else{
                this.fileList.forEach(item => {
                this.$http({
                    url:"api/input_file/",
                    method:"POST",
                    data:{
                        input_file:item.raw,
                        is_tran:this.radio,
                        organ_name:localStorage.getItem("organ_name"),
                    },
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                }).then(res=>{
                    if(res.data.code == 400){
                        this.fileList = null
                        this.$confirm(res.data.message, '提示', {
                        confirmButtonText: '确定',
                        showCancelButton:false,
                        type: 'warning',
                        center: true
                    })

                    }else{
                        this.fileList = []
                        this.$refs.upload.clearFiles()
                        this.dialog = true
                        this.$message.success("上传成功")
                        this.$router.push({
                        name: "user",
                    });
                    }
                })
            });
            }
            
            
           
        },
        // 取消
        cancel(){
            this.fileList = []
            this.dialog = false
        },
        // 确认
        confirm(){
            this.dialog = false
        }
        
    },

}
</script>

<style lang="scss" scoped>
* {
    box-sizing: border-box;
}
// 下一步按钮
// .el-button--primary {
//     color: #FFF;
//     background-color: #1296db;
//     border-color: #1296db;
//     width: 160px;
//     height: 50px;
//     margin: 0 auto;
//     cursor: pointer;
    
// }
// #1296db
::v-deep .el-step__head.is-finish{
    color: #9250e6;
    border-color: #9250e6;
}
::v-deep .el-step__title.is-finish{
    color: #9250e6;
}
::v-deep .el-radio__input.is-checked .el-radio__inner{
    background: #9250e6;
    border-color: #9250e6;
}
::v-deep .el-radio__input.is-checked+.el-radio__label{
    color: #9250e6;
}
::v-deep .el-radio__inner:hover{
    color: #9250e6;
}
::v-deep .el-button--primary{
    background: #9250e6;
    border-color: #9250e6;
}
::v-deep .el-upload-dragger {
    background-color: #fff;
    border: none;
    border-radius: 6px;
    box-sizing: border-box;
    width: 360px;
    height: 180px;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
}
.ulStyle{
    list-style: disc;
}
.upload_tip_img{
    position: absolute;
    left: 50%;
    top: -50px;
    width: 100px;
    height: 100px;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
}
.upload_tip_p{
    margin-bottom: 4px;
    line-height: 1.5;
    color: #777;
}
.upload_tip_text{
    margin-top: 16px;
    padding: 20px;
}
.upload_tab{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-top: 20px;
}
.upload_tab .upload_tab_item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    border-radius: 4px 4px 0 0;
    height: 40px;
    width: 120px;
    margin-right: 20px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    color: #fff;
    background-color: #46535d;
    cursor: pointer;
}
.upload_file{
    position: relative;
    border: 1px solid #ccc;
    padding: 30px 20px;
}
.flex{
    display: flex;
    position: relative;
    justify-content: center;
}
.upload-demo{
    text-align: center;
}
.upload_tip{
    position: relative;
    margin-top: 14px;
    background-color: #f0f7fd;
    -webkit-box-shadow: 0 2px 8px 0 rgb(0 0 0 / 25%);
    box-shadow: 0 2px 8px 0 rgb(0 0 0 / 25%);
    cursor: pointer;
}
.uplound{
    margin: 20px 20%;
    padding: 40px;
    background-color: white;
}
@media screen and (max-width: 1600px){
    .uplound{
        margin: 20px 10%;
        padding: 40px;
        background-color: white;
    }
}
.explain{
    margin-bottom: 20px;
}
.explain .explain_item{
    position: relative;
    height: 30px;
    line-height: 30px;
    margin-bottom: 6px;
}
.explain .explain_item .explain_item_span{
    display: inline-block;
    line-height: 22px;
    text-align: center;
    border: 1px solid #18402f;
    border-right: none;
    color: #18402f;
    width: 60px;
    height: 26px;
    margin-right: 20px;
}
.explain .explain_item .triangle{
    position: absolute;
    // top: -2.5px;
    // left: 0;
    left: 51px;
    bottom: -10px;
}

</style>